import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';
import auth from './auth.module';
import htmlClass from './htmlclass.module';
import config from './config.module';
import breadcrumbs from './breadcrumbs.module';
import activetabs from './activetabs.module';
import oidc from './oidc';
import tagsView from './tags-view';
import { RepoFactory } from '@/baseRepository/Factory';
import Helper from '@/core/helpers';
const businessInformationConversationRepository = () =>
  RepoFactory.get('businessInformationConversation');
window.addEventListener('beforeunload', function () {
  localStorage.removeItem('vuex');
});

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  reducer: (state) => ({
    itemStore: state.itemStore,
  }),
});
Vue.use(Vuex);

const context = require.context('@/modules', true, /store\/index.js/);

const modules = {};

context.keys().forEach((file) => {
  const moduleName = file.replace(/(\.\/|\/index\.js$)/g, '').split('/')[0];

  modules[moduleName] = context(file).default || context(file);
});

export default new Vuex.Store({
  modules: {
    oidc,
    auth,
    tagsView,
    htmlClass,
    config,
    breadcrumbs,
    activetabs,
    ...modules,
  },
  state: {
    drawer: null,
    shortCuts: {
      saveKeyCode: 83,
      newKeyCode: 78,
      listKeyCode: 76,
    },
    authorize: null,
    userDetails: null,
    urls: {
      file: '',
    },
    smsSenderLineNo:'',
    neshanApiKey: '',
    merchantBaseUrl: '',
    employeeBaseUrl: '',
    uiExternalUrl: '',
    inventoryBaseUrl: '',
    tradeBaseUrl: '',
    accountingServicesBaseUrl: '',
    saleBaseUrl: '',
    walletBaseUrl: '',
    accountingServiceBaseUrl: '',
    productBaseUrl: '',
    taksaanAcademyUrl: '',
    taksaanUrl: '',
    contentBaseUrl: '',
    fileBaseUrl: '',
    uniquePageName: '',
    uniquePageNameBuyers: '',
    uniquePageApprovingTaksaanRuleOnTrade: '',
    authBaseUrl: '',
    settingBaseUrl: '',
    userAvatar: require('@/assets/profile-placeholder.png'),
    crmExtrnalUrl: '',
    tradeImageSrc1: '',
    tradeImageSrc2: '',
    tradeImageSrc3: '',
    subscriptionBaseUrl: '',
    tradeImageSrc4: '',
    paymentBaseUrl: '',
    baseUrl: '',
    notificationBaseUrl: '',
    pageOrderWinnerNoticesFromTakssan: '',
    uniqPageSendOrderToAdmin: '',
    clientId: '',
    uniquePageApprovingTaksaanRuleOnMerchantsRegistration: null,
    footerMessage: null,
    footerMessageLabel: null,
    panelLogo: null,
    footerAddressRegistrationPanel: null,
    footerPhoneRegistrationPanel: null,
    registrationPanelLogo: null,
    dashboardLogo: null,
    footerLink: null,
    unreadeMessageCount: null,
    panelTitle: null,
    panelFavicon: null,
    infoMessageForSupplierInTempSPanel: null,
    infomessageForBuyerİnTempSPanel: null,
    DeleteUserRoleFromDashboardMessage: false,
    SupplierPanelTrailDays: null,
    membershipPlan: null,
    availabileTime: null,
    availabileTrialTime: null,
    autoChargeMonyForConsumerFounderUser: 0,
    autoChargeMonyForSupplierFounderUser: 0,
    subscriptionBasePlaneForBuyersId:0,
    subscriptionBasePlaneForSuppliersId:0,
    baseMembershipforConsumerCost:0,
    baseMembershipforSupplierCost: 0,
    currentUserIsVisitor: false,
    visitorsPhoneList: [],
    userWalletCredit:0,
  },
  getters: {
    subscriptionBaseUrl: (state) => state.subscriptionBaseUrl,
    walletBaseUrl: (state) => state.walletBaseUrl,
    uniqPageSendOrderToAdmin: (state) => state.uniqPageSendOrderToAdmin,
    notificationBaseUrl: (state) => state.notificationBaseUrl,
    paymentBaseUrl: (state) => state.paymentBaseUrl,
    pageOrderWinnerNoticesFromTakssan: (state) =>
      state.pageOrderWinnerNoticesFromTakssan,
    baseUrl: (state) => state.baseUrl,
    neshanApiKey: (state) => state.neshanApiKey,
    smsSenderLineNo:(state)=> state.smsSenderLineNo,
    merchantBaseUrl: (state) => state.merchantBaseUrl,
    employeeBaseUrl: (state) => state.employeeBaseUrl,
    uiExternalUrl: (state) => state.uiExternalUrl,
    urls: (state) => state.urls,
    inventoryBaseUrl: (state) => state.inventoryBaseUrl,
    tradeBaseUrl: (state) => state.tradeBaseUrl,
    accountingServicesBaseUrl: (state) => state.accountingServicesBaseUrl,
    saleBaseUrl: (state) => state.saleBaseUrl,
    notificationBaseUrl: (state) => state.notificationBaseUrl,
    accountingServiceBaseUrl: (state) => state.accountingServiceBaseUrl,
    productBaseUrl: (state) => state.productBaseUrl,
    shortCuts: (state) => state.shortCuts,
    taksaanAcademyUrl: (state) => state.taksaanAcademyUrl,
    taksaanUrl: (state) => state.taksaanUrl,
    contentBaseUrl: (state) => state.contentBaseUrl,
    fileBaseUrl: (state) => state.fileBaseUrl,
    uniquePageName: (state) => state.uniquePageName,
    uniquePageNameBuyers: (state) => state.uniquePageNameBuyers,
    uniquePageApprovingTaksaanRuleOnTrade: (state) =>
      state.uniquePageApprovingTaksaanRuleOnTrade,
    authBaseUrl: (state) => state.authBaseUrl,
    settingBaseUrl: (state) => state.settingBaseUrl,
    authorize: (state) => state.authorize,
    userDetails: (state) => state.userDetails,
    crmExtrnalUrl: (state) => state.crmExtrnalUrl,
    tradeImageSrc1: (state) => state.tradeImageSrc1,
    tradeImageSrc2: (state) => state.tradeImageSrc2,
    tradeImageSrc3: (state) => state.tradeImageSrc3,
    tradeImageSrc4: (state) => state.tradeImageSrc4,
    clientId: (state) => state.clientId,
    uniquePageApprovingTaksaanRuleOnMerchantsRegistration: (state) =>
      state.uniquePageApprovingTaksaanRuleOnMerchantsRegistration,
    footerMessage: (state) => state.footerMessage,
    footerMessageLabel: (state) => state.footerMessageLabel,
    panelLogo: (state) => state.panelLogo,
    footerAddressRegistrationPanel: (state) =>
      state.footerAddressRegistrationPanel,
    footerPhoneRegistrationPanel: (state) => state.footerPhoneRegistrationPanel,
    registrationPanelLogo: (state) => state.registrationPanelLogo,
    dashboardLogo: (state) => state.dashboardLogo,
    footerLink: (state) => state.footerLink,
    unreadeMessageCount: (state) => state.unreadeMessageCount,
    panelTitle: (state) => state.panelTitle,
    panelFavicon: (state) => state.panelFavicon,
    infoMessageForSupplierInTempSPanel: (state) =>
      state.infoMessageForSupplierInTempSPanel,
    infomessageForBuyerİnTempSPanel: (state) =>
      state.infomessageForBuyerİnTempSPanel,
    DeleteUserRoleFromDashboardMessage: (state) =>
      state.DeleteUserRoleFromDashboardMessage,
    SupplierPanelTrailDays: (state) => state.SupplierPanelTrailDays,
    membershipPlan: (state) => state.membershipPlan,
    availabileTime: (state) => state.availabileTime,
    availabileTrialTime: (state) => state.availabileTrialTime,
    autoChargeMonyForConsumerFounderUser: (state) => state.autoChargeMonyForConsumerFounderUser,
    autoChargeMonyForSupplierFounderUser: (state) => state.autoChargeMonyForSupplierFounderUser,
    subscriptionBasePlaneForBuyersId: (state) => state.subscriptionBasePlaneForBuyersId,
    subscriptionBasePlaneForSuppliersId: (state) => state.subscriptionBasePlaneForSuppliersId,
    baseMembershipforConsumerCost: (state) => state.baseMembershipforConsumerCost,
    baseMembershipforSupplierCost: (state) => state.baseMembershipforSupplierCost,
    currentUserIsVisitor: (state) => state.currentUserIsVisitor,
    visitorsPhoneList: (state) => state.visitorsPhoneList,
    userWalletCredit: (state) => state.userWalletCredit,
  },
  mutations: {
    SET_CONFIG(state, payload) {
      state.uniqPageSendOrderToAdmin = payload.uniq_Page_Send_Order_To_Admin;
      state.paymentBaseUrl = payload.SERVICE_PAYMENT_EXTERNAL_URL;
      state.walletBaseUrl = payload.SERVICE_WALLET_EXTERNAL_URL;
      state.pageOrderWinnerNoticesFromTakssan =
        payload.PAGE_ORDER_WINNER_NOTICES_FROM_TAKSSAN;
      state.neshanApiKey = payload.NESHAN_FIND_SERVICE_API;
      state.smsSenderLineNo = payload.SMS_SENDER_LINE_NO;
      state.authBaseUrl = payload.SERVICE_AUTH_EXTERNAL_URL;
      state.settingBaseUrl = payload.SERVICE_SETTING_EXTERNAL_URL;
      state.subscriptionBaseUrl = payload.SERVICE_SUBSCRIPTION_EXTERNAL_URL;
      state.baseUrl = payload.SERVICE_UI_EXTERNAL_URL;
      state.urls.file = payload.SERVICE_FILE_EXTERNAL_URL;
      state.merchantBaseUrl = payload.SERVICE_MERCHANT_EXTERNAL_URL;
      state.employeeBaseUrl = payload.SERVICE_HUMAN_RESOURCE_EXTERNAL_URL;
      state.saleBaseUrl = payload.SERVICE_SALE_URL;
      state.uiExternalUrl = payload.SERVICE_UI_TAKSAAN_SUPPLIER_EXTERNAL_URL;
      state.inventoryBaseUrl = payload.SERVICE_INVENTORY_EXTERNAL_URL;
      state.tradeBaseUrl = payload.SERVICE_TRADE_EXTERNAL_URL;
      state.notificationBaseUrl = payload.SERVICE_NOTIFICATION_EXTERNAL_URL;
      state.taksaanAcademyUrl = payload.SERVICE_UI_TAKSAAN_ACADEMY_EXTERNAL_URL;
      state.taksaanUrl = payload.SERVICE_UI_TAKSAAN_EXTERNAL_URL;
      state.accountingServicesBaseUrl = payload.SERVICE_ACCOUNTING_EXTERNAL_URL;
      (state.saleBaseUrl = payload.SERVICE_SALE_EXTERNAL_URL),
        (state.accountingServiceBaseUrl =
          payload.SERVICE_ACCOUNTING_EXTERNAL_URL);
      state.productBaseUrl = payload.SERVICE_PRODUCT_EXTERNAL_URL;
      state.contentBaseUrl = payload.SERVICE_CONTENT_EXTERNAL_URL;
      state.fileBaseUrl = payload.SERVICE_FILE_EXTERNAL_URL;
      state.uniquePageName = payload.UNIQUE_PAGE_NAME;
      state.uniquePageNameBuyers = payload.UNIQUE_PAGE_NAME_BUYERS;
      state.uniquePageApprovingTaksaanRuleOnTrade =
        payload.UNIQUE_PAGE_APPROVING_TAKSAAN_RULE_ON_TRADE;
      state.crmExtrnalUrl = payload.SERVICE_UI_SUPPORT_CRM_EXTERNAL_URL;
      state.tradeImageSrc1 = payload.TRADE_REQUEST_IMAGE_SRC_STEP_ONE;
      state.tradeImageSrc2 = payload.TRADE_REQUEST_IMAGE_SRC_STEP_TWO;
      state.tradeImageSrc3 = payload.TRADE_REQUEST_IMAGE_SRC_STEP_THREE;
      state.tradeImageSrc4 = payload.TRADE_REQUEST_IMAGE_SRC_STEP_FOUR;
      state.clientId = payload.CLIENT_ID;
      state.uniquePageApprovingTaksaanRuleOnMerchantsRegistration =
        payload.UNIQUE_PAGE_APPROVING_TAKSAAN_RULE_ON_MERCHANT_REGISTRATION;
      state.footerMessage = payload.footer_message;
      state.footerMessageLabel = payload.footerMessageLabel;
      state.panelLogo = payload.panelLogo;
      state.footerAddressRegistrationPanel =
        payload.footerAddressRegistrationPanel;
      state.footerPhoneRegistrationPanel = payload.footerPhoneRegistrationPanel;
      state.registrationPanelLogo = payload.registrationPanelLogo;
      state.dashboardLogo = payload.dashboardLogo;
      state.footerLink = payload.footerLink;
      state.panelTitle = payload.SERVICE_BUSINESS_NAME;
      state.panelFavicon = payload.SERVICE_BUSINESS_FAVICON;
      state.infoMessageForSupplierInTempSPanel =
        payload.infoMessageForSupplierInTempSPanel;
      state.infomessageForBuyerİnTempSPanel =
        payload.infomessageForBuyerİnTempSPanel;
      state.DeleteUserRoleFromDashboardMessage =
       payload.DeleteUserRoleFromDashboardMessage;
      state.SupplierPanelTrailDays = payload.SupplierPanelTrailDays;
      state.autoChargeMonyForConsumerFounderUser = payload.autoChargeMonyForConsumerFounderUser;
      state.autoChargeMonyForSupplierFounderUser = payload.autoChargeMonyForSupplierFounderUser;
      state.subscriptionBasePlaneForBuyersId = payload.subscriptionBasePlaneForBuyersId;
      state.subscriptionBasePlaneForSuppliersId = payload.subscriptionBasePlaneForSuppliersId;
      state.baseMembershipforConsumerCost = payload.baseMembershipforConsumerCost;
      state.baseMembershipforSupplierCost = payload.baseMembershipforSupplierCost;
      
    
    },
    setAuthorize(state, payload) {
      state.authorize = payload;
    },
    setUserDetails(state, payload) {
      state.userDetails = payload;
    },
    SET_USER_AVATAR(state, payload) {
      state.userAvatar = payload;
    },
    setUnreadeMessageCount(state, payload) {
      state.unreadeMessageCount = payload;
    },
    setMembershipPlan(state, payload) {
      state.membershipPlan = payload;
    },
    setAvailabileTime(state, payload) {
      state.availabileTime = payload;
    },
    setAvailabileTrialTime(state, payload) {
      state.availabileTrialTime = payload;
    },
    setCurrentUserIsVisitor(state, payload) {
      state.currentUserIsVisitor = payload;
    },
    setVisitorsPhoneList(state, payload) {
      state.visitorsPhoneList = payload;
    },
    setUserWalletCredit(state, payload) {
      state.userWalletCredit = payload;
    }

    
  },
  actions: {
    getUnreadTreadeConversation({ commit, state }, currentMerchant) {
      if (!currentMerchant) return
      return new Promise((resolve, reject) => {
        businessInformationConversationRepository()
          .getUnreadTreadeConversation(state.contentBaseUrl, {
            MerchantId: currentMerchant,
          })
          .then((res) => {
            commit('setUnreadeMessageCount', res.data);
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
  plugins: [vuexLocal.plugin],
});
